import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Card,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import Loader from '../../../commons/loader';
import DropZone from 'react-dropzone';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from '../services';
import { PaginationTotal, ImageCard } from '../../../commons/controls';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';

class BufeKinalatListaContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,
      currentRow: {},
      enums: [],
      helyszin: {},
      helyszinek: [],
      helyszinid: {},
      modalNezet: false,
      modalBufelista: false,
      modalBufelistaModosit: false,
      modalBufelistaTorles: false,
      bufelista: {},
      bufelistaJson: [],
      bufelistaModositObj: {},
      tipus: '',
      img: null,
      imgLoaded: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDE']
      tableStatus: 'HIDE',
      helyszinOptions: [],
    };
    this.segedTomb = [];
    this.options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ]
    };
  }

  componentDidMount() {
    this.getHelyszinek();
    this.checkAngolNyelv();
  }

  checkAngolNyelv = () => {
    Service.getAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  handleBufelistaEditClick = (id) => {
    this.setState((prevState) => {
      this.kepValasztasHigh(prevState, id);
      return ({ bufelistaModositObj: prevState.bufelistaJson.find(element => element.id === id) });
    }, () => {
      this.toggleBufelistaModosit();
    });
  }

  handleBufelistaDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleBufelistaTorles();
  }

  handleViewClick = (id) => {
    let bufelista = this.state.bufelistaJson.find(bufelista => bufelista.id === id);
    this._currentViewId = id;
    this.setState({ bufelista: bufelista }, () => {
      this.toggleNezet(id);
    });
  }

  handleBufeLista = (id, rowObj, rowIndex, plus) => {
    let mostani = this.state.bufelistaJson.find((element) => {
      return element === rowObj;
    });
    let masik = this.state.bufelistaJson[rowIndex + plus];
    let sorszamseged = mostani.sorszam;
    mostani.sorszam = masik.sorszam;
    masik.sorszam = sorszamseged;
    this.state.bufelistaJson.sort((a, b) => {
      return a.sorszam - b.sorszam;
    });
    this.setState({ bufelistaJson: this.state.bufelistaJson });
  }

  iconFormatter = (cell, rowObj, rowIndex) => {
    return (
      <div>
        {
          <>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} />
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleBufelistaEditClick(cell)} />
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleBufelistaDeleteClick(cell)} />
            <Button style={{ visibility: rowIndex === 0 ? 'hidden' : 'visible' }} className="table-action-icon" id={'action-view-' + cell + 'fel'} onClick={() => { this.handleBufeLista(cell, rowObj, rowIndex, -1) }} disabled={rowIndex === 0}>
              <i class="fa fa-arrow-up" />
            </Button>
            <Button style={{ visibility: (rowIndex === this.state.bufelistaJson.length - 1) ? 'hidden' : 'visible' }} className="table-action-icon" id={'action-view-' + cell + 'le'} onClick={() => { this.handleBufeLista(cell, rowObj, rowIndex, 1) }} disabled={rowIndex === this.state.bufelistaJson.length - 1}>
              <i class="fa fa-arrow-down" />
            </Button>
          </>
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'fel'} delay={0}>Eltolás felfele</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'le'} delay={0}>Eltolás lefele</UncontrolledTooltip>
      </div>
    );
  }

  statusFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-default">Nem</span>;
  }

  getHelyszinek = () => {
    Service.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach(e => options.push(<option key={e.id} value={e.id}>{e.nev}</option>));

        this.setState({
          helyszinek: res[0],
          helyszinOptions: options,
          helyszinid: res[0].length === 1 ? res[0][0].id : '',
          helyszin: res[0].length === 1 ? res[0][0] : {}
        });

        if (res[0].length === 1) {
          this.updateTable();
        }
      }
    });
  };

  helyszinValaszto = () => {
    return (
      <RFForm onSubmit={() => {}}>
        <RFField
          type="select"
          name="formHelyszin"
          label="Helyszín neve:"
          value={this.state.helyszinid}
          onChange={this.handleHelyszinSelectChange}
          defaultSelect={<option value=''>Válassz helyszínt...</option>}
          selectOptions={this.state.helyszinOptions}
        />
      </RFForm>
    );
  }

  handleHelyszinSelectChange = (e) => {
    const { target } = e;
    const value = target.value;
    this.setState({
      helyszinid: value,
      helyszin: this.state.helyszinek.find(helyszin => { return helyszin.id == value })
    }, () => {
      if (value !== '') this.updateTable();
      else this.setState({ bufelistaJson: [], tableStatus: 'HIDE' });
    });
  }

  handleBufelistaTipusSelectChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      tipus: value,
    });
  }

  getBufeKinalatList = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Service.listBufelista(this.state.helyszinid, (err, res) => {
        if (!err) {
          this.setState({ bufelistaJson: res[0], tableStatus: res[0].length > 0 ? 'TABL' : 'DATA' });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  renderBufelistaTipusOptions = () => {
    return this.state.enums.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  }

  renderTipusok = () => {
    let tipusok = {};
    this.state.enums.forEach(e => Object.assign(tipusok, { [JSON.stringify(e)]: e.caption }));
    return tipusok;
  }

  updateTable = () => {
    this.getBufeKinalatList();
  }

  setImgObject = (imgObj, stateObj) => {
    if (imgObj.angol == true)
      stateObj.imgAngol = imgObj;
    else
      stateObj.img = imgObj;
  }

  kepValasztasHigh = (prevState, id) => {
    this.setState({ imgLoaded: false });
    let bufelista = prevState.bufelistaJson.find(element => element.id === id);
    if (bufelista.objects !== null) {
      Service.getBufelista(bufelista.id, (err, res) => {
        if (!err) {
          let stateObj = {};
          if (res[0] != null && res[0].objects != null) {
            for (let i = 0; i < res[0].objects.length; i++) {
              this.setImgObject(res[0].objects[i], stateObj);
            }
          }
          this.setState(stateObj);
        }
        this.setState({ imgLoaded: true });
      });
    }
    this.setState({ imgLoaded: true });
  }

  toggleNezet = (id) => {
    this.setState((prevState) => {
      if (prevState.modalNezet === false)
        this.kepValasztasHigh(prevState, id);
      return ({ modalNezet: !prevState.modalNezet, img: prevState.modalNezet === true ? null : this.state.img, imgAngol: prevState.modalNezet === true ? null : this.state.imgAngol });
    });
  }

  toggleBufelista = () => {
    this.setState((prevState) => { return ({ modalBufelista: !prevState.modalBufelista, img: null, imgAngol: null }); });
  }

  toggleBufelistaModosit = () => {
    this.setState((prevState) => { return ({ modalBufelistaModosit: !prevState.modalBufelistaModosit, img: prevState.modalBufelistaModosit === true ? null : this.state.img, imgAngol: prevState.modalBufelistaModosit === true ? null : this.state.imgAngol }); });
  }

  toggleBufelistaTorles = () => {
    this.setState((prevState) => { return ({ modalBufelistaTorles: !prevState.modalBufelistaTorles }); });
  }

  toggleKepModal = () => {
    this.setState(prevState => ({ kepModal: !prevState.kepModal }));
  }

  toggleKepAngolModal = () => {
    this.setState(prevState => ({ kepAngolModal: !prevState.kepAngolModal }));
  }

  onDropPlakat = (acceptedfiles, angol) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files;
        if (angol == true)
          files = this.state.imgAngol || [];
        else
          files = this.state.img || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          angol: angol == true,
          //id: Lib.Browser.uuidv4(),
        });
        if (angol == true)
          this.setState({ imgAngol: files[0] });
        else
          this.setState({ img: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  onDropPlakatAngol = (acceptedfiles) => {
    this.onDropPlakat(acceptedfiles, true);
  }

  addBufelista = (event, bufelistaObj) => {
    let objects = [];
    objects.push(this.state.img);
    if (this.state.angolNyelv == true)
      objects.push(this.state.imgAngol);
    bufelistaObj.helyszinid = this.state.helyszinid;
    bufelistaObj.objects = objects;
    Service.addBufelista(bufelistaObj, (err) => {
      if (!err) {
        this.toggleBufelista();
        this.updateTable();
        this.props.globals.addSuccess('Büfé kínálat hozzáadva!');
      }
    });
  }

  editBufelista = (event, bufelistaModositObj) => {
    let objects = [];
    if (this.state.img !== null) {
      objects.push(this.state.img);
    }
    if (this.state.angolNyelv == true) {
      if (this.state.imgAngol !== null)
        objects.push(this.state.imgAngol);
      this.state.bufelistaModositObj.cimangol = bufelistaModositObj.cimangol;
    }
    this.state.bufelistaModositObj.objects = objects;
    this.state.bufelistaModositObj.slider = bufelistaModositObj.slider;
    this.state.bufelistaModositObj.cim = bufelistaModositObj.cim;
    Service.modifyBufelista(this.state.bufelistaModositObj, (err) => {
      if (!err) {
        this.toggleBufelistaModosit();
        this.updateTable();
        this.props.globals.addSuccess('Büfé kínálat módosítva!');
      }
    });
  }

  deleteBufelista = () => {
    this.toggleBufelistaTorles();
    Service.deleteBufelista(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.setState({ currentRow: [] });
        this.props.globals.addSuccess('Büfé kínálat törölve!');
      }
    });
  }

  rendez = () => {
    let rendezesBean = {};
    rendezesBean.idk = this.state.bufelistaJson.map((element) => {
      return element.id;
    });
    rendezesBean.helyszinid = this.state.helyszinid;
    Service.rendezBufelista(rendezesBean, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Sorrend sikeresen elmentve!');
        this.updateTable();
      }
    });
  }

  renderAdatok = () => {
    return (
      <div>
        <b>Helyszín neve: </b>{this.state.helyszin.nev}<br />
        <b>Cím: </b>{this.state.bufelista.cim}<br />
        {this.state.angolNyelv == true ? <div><b>Cím (angol): </b>{this.state.bufelista.cimangol}<br /></div> : <div />}
        <b>Slider: </b>{this.state.bufelista.slider === true ? "Igen" : "Nem"}<br />
        <br />
        <h6>Kép:</h6><br />
        <Card inverse style={{ backgroundColor: "#000" }} >
          <CardImg
            src={this.state.img ? this.state.img.src ? this.state.img.src : "data:image/bmp;base64," + this.state.img.content : ''}
          />
        </Card>
        {this.state.angolNyelv == true ? <div>
          <h6>Kép (angol):</h6><br />
          <Card inverse style={{ backgroundColor: "#000" }} >
            <CardImg
              src={this.state.imgAngol ? this.state.imgAngol.src ? this.state.imgAngol.src : "data:image/bmp;base64," + this.state.imgAngol.content : ''}
            />
          </Card>
        </div> : <div />}
      </div>
    );
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'cim',
        text: 'Büfé kínálat címe',
      },
      {
        dataField: 'slider',
        text: 'Slider',
        align: 'center',
        formatter: this.statusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    if (this.state.angolNyelv == true)
      columns.splice(1, 0, {
        dataField: 'cimangol',
        text: 'Büfé kínálat címe (angol)',
      });

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.bufelistaJson}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            {this.helyszinValaszto()}
          </div>
        </div>
        <div className="row">
          {(this.state.tableStatus === 'DATA' || this.state.tableStatus === 'TABL') &&
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.toggleBufelista}>Új büfé kínálat hozzáadása</Button>
            </div>
          }
        </div>
        <div className="row">
          <div className="col-md-12">
            {(this.state.tableStatus === 'TABL' ? this.renderTable() : this.state.tableStatus === 'NETW' ? <NetworkEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableStatus === 'LOAD' ? <Loader /> : <div />)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2" style={{ float: 'right' }}>
            {(this.state.tableStatus === 'TABL' ?
              <Button type="button" id="rendez" className="btn-cursor-pointer" color="success" onClick={this.rendez} style={{ paddingLeft: 10 }}><i className="fa fa-check" style={{ paddingLeft: 0, paddingRight: 5 }} />Sorrend mentése</Button>
              : <div />)}
          </div>
        </div>
        <Modal isOpen={this.state.modalBufelista} toggle={this.toggleBufelista} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={this.addBufelista}
            title="Büfé kínálat felvétel"
            footer={
              <>
                <Button color="primary">Mentés</Button>{' '}
                <Button type="button" color="secondary" onClick={this.toggleBufelista}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-9">
                <RFField
                  name="cim"
                  label="Cím: *"
                  errorMessage="Kötelező mező!"
                  maxLength={25}
                  required
                />
              </div>
              <div className="col-md-3">
                <div className="row" style={{ paddingTop: 35 }}>
                  <RFField
                    type="checkbox"
                    name="slider"
                    label="Slider"
                  />
                </div>
              </div>
            </div>
            {this.state.angolNyelv == true ?
              <div className="row">
                <div className="col-md-9">
                  <RFField
                    name="cimangol"
                    label="Cím (angol): *"
                    errorMessage="Kötelező mező!"
                    maxLength={25}
                    required
                  />
                </div>
              </div>
              : <div />
            }
            <div className="row">
              <div className="col-md-12">
                <Label >Kép:</Label>
                {!this.state.img &&
                  <DropZone id="img" onDrop={this.onDropPlakat} className="custom-dropzone">
                    {({getRootProps, getInputProps}) => (
                        <div {...getRootProps({ className: 'custom-dropzone'})}>
                          <input {...getInputProps()} />
                          <div className="dropzone-text">
                            {'Kép feltöltése!'}
                          </div>
                        </div>
                    )}
                  </DropZone>
                }
                {this.state.img &&
                  <ImageCard
                    mime={this.state.img.mime}
                    content={this.state.img.content}
                    src={this.state.img.src}
                    poster
                    onViewClick={this.toggleKepModal}
                    onDeleteClick={() => { this.setState({ img: null }) }}
                    noStyle
                  />
                }
              </div>
            </div>
            {this.state.angolNyelv == true ?
              <div className="row">
                <div className="col-md-12">
                  <Label >Kép (angol):</Label>
                  {!this.state.imgAngol &&
                  <DropZone id="imgAngol" onDrop={this.onDropPlakatAngol} className="custom-dropzone">
                    {({getRootProps, getInputProps}) => (
                        <div {...getRootProps({ className: 'custom-dropzone'})}>
                          <input {...getInputProps()} />
                          <div className="dropzone-text">
                            {'Kép feltöltése!'}
                          </div>
                        </div>
                    )}
                  </DropZone>
                }
                {this.state.imgAngol &&
                  <ImageCard
                    mime={this.state.imgAngol.mime}
                    content={this.state.imgAngol.content}
                    src={this.state.imgAngol.src}
                    poster
                    onViewClick={this.toggleKepAngolModal}
                    onDeleteClick={() => { this.setState({ imgAngol: null }) }}
                    noStyle
                  />
                }
                </div>
              </div>
              : <div />}
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalBufelistaModosit} toggle={this.toggleBufelistaModosit} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={this.editBufelista}
            title="Büfé kínálat módosítás"
            footer={
              <>
                <Button color="primary">Mentés</Button>{' '}
                <Button type="button" color="secondary" onClick={this.toggleBufelistaModosit}>Mégsem</Button>
              </>
            }
          >
            {
              !this.state.imgLoaded ? <Loader /> :
                <div>
                  <div className="row">
                    <div className="col-md-9">
                      <RFField
                        name="cim"
                        label="Cím: *"
                        value={this.state.bufelistaModositObj.cim}
                        errorMessage="Kötelező mező!"
                        maxLength={25}
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <div className="row" style={{ paddingTop: 35 }}>
                        <RFField
                          type="checkbox"
                          label="Slider"
                          name="slider"
                          value={this.state.bufelistaModositObj.slider ? this.state.bufelistaModositObj.slider : false}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.angolNyelv == true ?
                    <div className="row">
                      <div className="col-md-9">
                        <RFField
                          name="cimangol"
                          label="Cím (angol): *"
                          value={this.state.bufelistaModositObj.cimangol}
                          errorMessage="Kötelező mező!"
                          maxLength={25}
                          required
                        />
                      </div>
                    </div>
                    : <div />}
                  <div className="row">
                    <div className="col-md-12">
                      <Label >Kép:</Label>
                      {!this.state.img &&
                        <DropZone id="img" onDrop={this.onDropPlakat} className="custom-dropzone">
                          {({getRootProps, getInputProps}) => (
                              <div {...getRootProps({ className: 'custom-dropzone'})}>
                                <input {...getInputProps()} />
                                <div className="dropzone-text">
                                  {'Kép feltöltése!'}
                                </div>
                              </div>
                          )}
                        </DropZone>
                      }
                      {this.state.img &&
                        <ImageCard
                          mime={this.state.img.mime}
                          content={this.state.img.content}
                          src={this.state.img.src}
                          poster
                          onViewClick={this.toggleKepModal}
                          onDeleteClick={() => { this.setState({ img: null }) }}
                          noStyle
                        />
                      }
                    </div>
                  </div>
                  {this.state.angolNyelv == true ?
                    <div className="row">
                      <div className="col-md-12">
                        <Label >Kép (angol):</Label>
                        {!this.state.imgAngol &&
                          <DropZone id="imgAngol" onDrop={this.onDropPlakatAngol} className="custom-dropzone">
                            {({getRootProps, getInputProps}) => (
                                <div {...getRootProps({ className: 'custom-dropzone'})}>
                                  <input {...getInputProps()} />
                                  <div className="dropzone-text">
                                    {'Kép feltöltése!'}
                                  </div>
                                </div>
                            )}
                          </DropZone>
                        }
                        {this.state.imgAngol &&
                          <ImageCard
                            mime={this.state.imgAngol.mime}
                            content={this.state.imgAngol.content}
                            src={this.state.imgAngol.src}
                            poster
                            onViewClick={this.toggleKepAngolModal}
                            onDeleteClick={() => { this.setState({ imgAngol: null }) }}
                            noStyle
                          />
                        }
                      </div>
                    </div>
                    : <div />}
                </div>
            }
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalBufelistaTorles} toggle={this.toggleBufelistaTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a büfé kínálatot?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteBufelista}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleBufelistaTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader >Büfé kínálat információ</ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.state.imgLoaded ? this.renderAdatok(this._currentViewId) : <Loader /> : <div />}</ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={this.toggleNezet}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.kepModal} toggle={this.toggleKepModal} backdrop="static">
          <Card style={{ marginBottom: "0", border: "none" }}>
            <RFForm onSubmit={() => {}}>
              {this.state.img &&
                <React.Fragment>
                  <CardImg
                    src={this.state.img.src ? this.state.img.src : "data:image/bmp;base64," + this.state.img.content}
                    onClick={this.toggleKepModal} />
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <RFField
                      placeholder="Kép leírás..."
                      onChange={(e, v) => { this.setState(prevState => ({ img: { ...prevState.img, alt: v } })) }}
                      value={this.state.img.alt}
                      disabled={this.state.img.id}
                      name="imgAltTag"
                    />
                    <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleKepModal}>
                      OK
                    </Button>
                  </div>
                </React.Fragment>
              }
            </RFForm>
          </Card>
        </Modal>
        <Modal isOpen={this.state.kepAngolModal} toggle={this.toggleKepAngolModal} backdrop="static">
          <Card style={{ marginBottom: "0", border: "none" }}>
            <RFForm onSubmit={() => {}}>
              {this.state.imgAngol &&
                <React.Fragment>
                  <CardImg
                    src={this.state.imgAngol.src ? this.state.imgAngol.src : "data:image/bmp;base64," + this.state.imgAngol.content}
                    onClick={this.toggleKepAngolModal} />
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <RFField
                      placeholder="Kép leírás..."
                      onChange={(e, v) => { this.setState(prevState => ({ imgAngol: { ...prevState.imgAngol, alt: v } })) }}
                      value={this.state.imgAngol.alt}
                      disabled={this.state.imgAngol.id}
                      name="imgAltTag"
                    />
                    <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.toggleKepAngolModal}>
                      OK
                    </Button>
                  </div>
                </React.Fragment>
              }
            </RFForm>
          </Card>
        </Modal>
      </div>
    );
  }
};

export default BufeKinalatListaContent;
